import React, { useState, useEffect } from 'react';

function TypeWriter({ words, typeSpeed = 110, typeSpeeds, deleteSpeed = 100, pause = 4000, color = '#9ca3af' }) {
  const [wordIndex, setWordIndex] = useState(0);
  const [displayed, setDisplayed] = useState(words[0]);
  const [phase, setPhase] = useState('pause');

  useEffect(() => {
    const target = words[wordIndex];
    const speed = typeSpeeds ? (typeSpeeds[wordIndex] ?? typeSpeed) : typeSpeed;

    if (phase === 'pause') {
      const t = setTimeout(() => setPhase('deleting'), pause);
      return () => clearTimeout(t);
    }

    if (phase === 'deleting') {
      if (displayed.length === 0) {
        setWordIndex(i => (i + 1) % words.length);
        setPhase('typing');
        return;
      }
      const t = setTimeout(() => setDisplayed(d => d.slice(0, -1)), deleteSpeed);
      return () => clearTimeout(t);
    }

    if (phase === 'typing') {
      if (displayed === target) {
        setPhase('pause');
        return;
      }
      const t = setTimeout(() => setDisplayed(target.slice(0, displayed.length + 1)), speed);
      return () => clearTimeout(t);
    }
  }, [displayed, phase, wordIndex, words, typeSpeed, typeSpeeds, deleteSpeed, pause]);

  return (
    <>
      <style>{`
        @keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
        .tw-cursor { animation: blink 0.75s step-end infinite; }
      `}</style>
      <span style={{ color }}>{displayed}</span>
      <span className="tw-cursor" style={{ color, fontWeight: 300, marginLeft: 1 }}>|</span>
    </>
  );
}

export default TypeWriter;
